import React from 'react';
import { NavLink } from 'react-router-dom';
import { LayoutDashboard, Server, FileText, Users, LogOut, ChevronLeft, Menu, Shield, Layers } from 'lucide-react';
import { useAuth } from '../../context/AuthContext';
interface SidebarProps {
  isOpen: boolean;
  setIsOpen: (isOpen: boolean) => void;
}
export function Sidebar({
  isOpen,
  setIsOpen
}: SidebarProps) {
  const {
    user,
    logout
  } = useAuth();
  const toggleSidebar = () => setIsOpen(!isOpen);
  const navItems = [{
    name: 'Overview',
    path: '/',
    icon: LayoutDashboard
  }, {
    name: 'Technical Dashboard',
    path: '/technical',
    icon: Server
  }, {
    name: 'Billing Dashboard',
    path: '/billing',
    icon: FileText
  }, {
    name: 'Users',
    path: '/users',
    icon: Users
  }, {
    name: 'Roles',
    path: '/roles',
    icon: Shield
  }, {
    name: 'Services',
    path: '/services',
    icon: Layers
  }];
  return <aside className={`fixed top-0 left-0 z-40 h-screen transition-all duration-300 bg-slate-900 text-white border-r border-slate-800 ${isOpen ? 'w-64' : 'w-20'}`} data-id="element-43">
      {/* Header */}
      <div className="flex items-center justify-between h-16 px-4 border-b border-slate-800" data-id="element-44">
        {isOpen ? <div className="flex items-center space-x-2" data-id="element-45">
            <div className="w-8 h-8 bg-emerald-600 rounded-lg flex items-center justify-center font-bold text-lg" data-id="element-46">
              L
            </div>
            <span className="font-bold text-lg tracking-tight" data-id="element-47">
              LISF Portal
            </span>
          </div> : <div className="w-8 h-8 bg-emerald-600 rounded-lg flex items-center justify-center font-bold text-lg mx-auto" data-id="element-48">
            L
          </div>}
        <button onClick={toggleSidebar} className="p-1.5 rounded-lg hover:bg-slate-800 text-slate-400 hover:text-white transition-colors" data-id="element-49">
          {isOpen ? <ChevronLeft size={20} data-id="element-50" /> : <Menu size={20} data-id="element-51" />}
        </button>
      </div>

      {/* Navigation */}
      <nav className="p-4 space-y-2" data-id="element-52">
        {navItems.map(item => <NavLink key={item.path} to={item.path} className={({
        isActive
      }) => `
              flex items-center px-3 py-3 rounded-lg transition-colors group
              ${isActive ? 'bg-emerald-600 text-white' : 'text-slate-400 hover:bg-slate-800 hover:text-white'}
            `} data-id="element-53">
            <item.icon size={22} className={`${isOpen ? 'mr-3' : 'mx-auto'}`} data-id="element-54" />
            {isOpen && <span className="font-medium" data-id="element-55">{item.name}</span>}

            {/* Tooltip for collapsed state */}
            {!isOpen && <div className="absolute left-full ml-2 px-2 py-1 bg-slate-800 text-white text-xs rounded opacity-0 group-hover:opacity-100 pointer-events-none whitespace-nowrap z-50" data-id="element-56">
                {item.name}
              </div>}
          </NavLink>)}
      </nav>

      {/* Footer / User Info */}
      <div className="absolute bottom-0 left-0 w-full p-4 border-t border-slate-800 bg-slate-900" data-id="element-57">
        <div className={`flex items-center ${isOpen ? 'justify-between' : 'justify-center'}`} data-id="element-58">
          {isOpen && <div className="flex items-center space-x-3 overflow-hidden" data-id="element-59">
              <img src={user?.avatar || `https://ui-avatars.com/api/?name=${user?.name || 'User'}`} alt="User" className="w-8 h-8 rounded-full bg-slate-700" data-id="element-60" />
              <div className="flex-1 min-w-0" data-id="element-61">
                <p className="text-sm font-medium truncate" data-id="element-62">{user?.name}</p>
                <p className="text-xs text-slate-500 truncate" data-id="element-63">{user?.role}</p>
              </div>
            </div>}
          <button onClick={logout} className={`p-2 rounded-lg hover:bg-red-500/10 hover:text-red-500 text-slate-400 transition-colors ${!isOpen && 'mx-auto'}`} title="Logout" data-id="element-64">
            <LogOut size={20} data-id="element-65" />
          </button>
        </div>
      </div>
    </aside>;
}